import React, { useEffect, useState, useCallback } from 'react'
import {
  Grid,
  Container,
  useMediaQuery
} from '@material-ui/core'
import {
  HeaderHLPure,
  ButtonHLPure,
  SimpleLoading,
  LabelModalPure,
  ButtonAddHLPure,
  SearchBarHLPure,
  DialogYesNoHLPure,
  DropDownBtnHLPure,
  DialogSystemGLPure,
  GridSelectionHLPure,
  PromotionalFooterPure,
} from '../../pures'
import AdministrationTypeDocumentForm from './administration-type-documents-form.view'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import DocumentsType from './../../../services/documents-type.service'
import { filterBy } from '@progress/kendo-data-query'
import './administration-types-of-documents.css'
import { useTranslation } from 'react-i18next'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import AdministrationTypeDocumentDataProfile from './administration-type-documents-data-profile.view'

const HeaderColumns = (props) => {
  return <span className={(props.title === props.t('configuration.AdministrationTypeDocuments.tableHeader.name')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
}

const CellColumnIcon = ({ dataItem }) => {
  const isDocumento = dataItem.infoType === 'Documento'
  const aggregateFieldsIcon = 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Proceedings.svg'
  const filePdfIcon = 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/PDFIcon.svg'
  const iconSrc = isDocumento ? filePdfIcon : aggregateFieldsIcon

  return (
    <td>
      <div className='administration-types-of-documents-view__cell-content'>
        <img
          src={iconSrc}
          alt={isDocumento ? 'Documento' : 'Expediente'}
          className='administration-types-of-documents-view__icon'
        />
        <span><strong>{dataItem.document.name}</strong></span>
      </div>
    </td>
  )
}

const CellColumnText = ({ col, dataItem, t }) => {
  const ENV = process.env
  let content = ''
  if (col === 2) content = dataItem.name
  if (col === 3) {
    if (dataItem.dataProfile && dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_CONTRACT) content = t('configuration.AdministrationTypeDocuments.data.profile.contract')
    if (dataItem.dataProfile && dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_IDS) content = t('configuration.AdministrationTypeDocuments.data.profile.ids')
    if (dataItem.dataProfile && dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_PROOF_OF_ADDRESS) content = t('configuration.AdministrationTypeDocuments.data.profile.proofOfAddress')
  }

  return (
    <td>
      <div>
        <p className='grid-cell-subtitles'>{content}</p>
      </div>
    </td>
  )
}

const CellColumnBtns = (props) => {
  return (
    <td>
      <div className='grid-btn-div'>
        <button className='grid-btn-action' onClick={() => props.onChangePage(props.t('configuration.AdministrationTypeDocuments.details'), props.dataItem)}>
          <p>{props.t('assembliesPrincipalView.grid.btns.detail')}</p>
        </button>
        <button className='grid-btn-action' onClick={() => props.onChangePage(props.t('assembliesPrincipalView.grid.btns.define.profile.data'), props.dataItem)}>
          <p>{props.t('assembliesPrincipalView.grid.btns.define.profile.data')}</p>
        </button>
      </div>
      <div className='grid-btn-arrow' onClick={() => props.onChangePage(props.t('configuration.AdministrationTypeDocuments.details'), props.dataItem)}>
        <img alt='assemblies-arrow' src={ArrowBtnMobile} />
      </div >
    </td >
  )
}

const AdministrationTypesOfDocumentsView = (props) => {
  const {
    alerts,
    isLoading,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    toggleErrorRequestingFalse,
    messageError,
    selectedAlert,
    setViewDetails,
    setSelectedAlert,
    loadTypeDocuments,
    setNameComponentUser,
    dataProfileOptions,
    formatVariables,
    handleSumbitVariable,
    handleDeleteVariable
  } = props

  const { t } = useTranslation()

  const token = JSON.parse(localStorage.getItem('token'))?.idToken
  const documentsTypeService = new DocumentsType(process.env.REACT_APP_MIFIRMA_API)

  const [documentTypeFilter, setDocumentTypeFilter] = useState('0')
  const [selectPage, setSelectPage] = useState('Documento')
  const [viewMode, setViewMode] = useState('list')
  const [dataProfileSelected, setDataProfileSelected] = useState(null)

  const [textAreaValue, setTextAreaValue] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [analyzeAI, setAnalyzeAI] = useState(false)
  const [gridAction, setGridAction] = useState('')
  const [headerTitle, setHeaderTitle] = useState(t('configuration.AdministrationTypeDocuments.title2'))

  const [typeDocumentData, setTypeDocumentData] = useState([])

  const [viewDeleteDialog, setViewDeleteDialog] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)

  const is1600 = useMediaQuery('(max-width:1600px)')
  const is1200 = useMediaQuery('(max-width:1200px)')
  const is820 = useMediaQuery('(max-width:820px)')
  const is560 = useMediaQuery('(max-width:560px)')
  const hideActionsHeader = useMediaQuery('(max-width:912px)')

  let history = useHistory()

  let widthCellOne = '100px'
  let widthCellTwo = '50px'
  let widthCellThree = '60px'
  let widthCellFour = '70px'

  if (is1600) {
    widthCellFour = '100px'
  }

  if (is1200) {
    widthCellFour = '140px'
  }

  if (is560) {
    widthCellFour = '40px'
  }

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  let CellColumnOne = (props) => <CellColumnIcon {...props} t={t} />
  let CellColumnTwo = (props) => <CellColumnText {...props} t={t} col={2} />
  let CellColumnThree = (props) => <CellColumnText {...props} t={t} col={3} />
  let CellColumnFour = (props) => <CellColumnBtns {...props} t={t} onChangePage={onChangePage} />

  useEffect(() => {
    const filters = [
      {
        field: 'document.name',
        operator: 'contains',
        value: searchValue
      }
    ]

    if (documentTypeFilter === '1') {
      filters.push({ field: 'name', operator: 'eq', value: 'Documento' })
    } else if (documentTypeFilter === '2') {
      filters.push({ field: 'name', operator: 'eq', value: 'Expediente' })
    }

    const filter = {
      logic: 'and',
      filters
    }

    setTypeDocumentData(filterBy(alerts, filter))
  }, [alerts, searchValue, documentTypeFilter])

  const handleSaveTypeDocument = async () => {
    if (!inputValue || !selectPage) {
      toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.incompleteFields'), 4000, false, '/')
      return
    }

    toggleLoadingRequesting(true)
    try {
      const documentCreated = await documentsTypeService.postTypeDocument(inputValue, selectPage, textAreaValue, dataProfileSelected, analyzeAI, token)
      if (documentCreated && documentCreated.data && Number(documentCreated.statusCode) === 200) {
        toggleLoadingRequesting(false)
        toggleCompletedRequesting(4000, false, '/')
        setTimeout(async () => {
          setInputValue('')
          setSelectPage('')
          setTextAreaValue('')
          setViewMode('list')
          setHeaderTitle(t('configuration.AdministrationTypeDocuments.title2'))
          setDataProfileSelected(null)
          setNameComponentUser('Administración de tipos de documentos')

          await loadTypeDocuments()
        }, 4000)
      } else {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(t("configuration.AdministrationTypeDocuments.error.save"), 4000, false, '/')
      }
    } catch (error) {
      toggleLoadingRequesting(false)
      toggleErrorRequesting(t("configuration.AdministrationTypeDocuments.error.save"), 4000, false, '/')
    }
  }

  const handleAddNewType = useCallback(() => {
    setInputValue('')
    setSelectPage('Documento')
    setTextAreaValue('')
    setAnalyzeAI(false)
    setViewMode('add')
    setNameComponentUser('Nuevo tipo de documento')
    setGridAction('add')
    setDataProfileSelected(null)
  }, [setViewMode, setNameComponentUser])

  const handleUpdateTypeDocument = async () => {
    if (!inputValue || !selectPage || !selectedAlert) {
      toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.incompleteFields'), 4000, false, '/')
      return
    }

    toggleLoadingRequesting(true)
    try {
      const typeDocumentUpdated = await documentsTypeService.putTypeDocument(
        selectedAlert.document.id,
        inputValue,
        selectPage,
        textAreaValue,
        dataProfileSelected,
        analyzeAI,
        token
      )

      if (typeDocumentUpdated && typeDocumentUpdated.data && Number(typeDocumentUpdated.statusCode) === 200) {
        toggleLoadingRequesting(false)
        toggleCompletedRequesting(4000, false, '/')
        setTimeout(async () => {
          setHeaderTitle(t('configuration.AdministrationTypeDocuments.title2'))
          setViewMode('list')
          setNameComponentUser('Administración de tipos de documentos')
          await loadTypeDocuments()
        }, 4000)
      } else if (typeDocumentUpdated && typeDocumentUpdated.statusCode && Number(typeDocumentUpdated.statusCode) === 409) {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.profile.data.values'), 4000, false, '/')
      } else {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.update'), 4000, false, '/')
      }

    } catch (error) {
      toggleLoadingRequesting(false)
      toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.update'), 4000, false, '/')
    }
  }

  useEffect(() => {
    if (viewMode === 'detail' && selectedAlert) {
      setInputValue(selectedAlert.document.name || '')
      setTextAreaValue(selectedAlert.document.description || '')
      setSelectPage(selectedAlert.infoType || 'Documento')
      setDataProfileSelected(selectedAlert.dataProfile || null)
      setAnalyzeAI(selectedAlert.analyzeAI || false)
    }

    if (viewMode === 'add') {
      const valueFilter = (documentTypeFilter === '2') ? 'Expediente' : 'Documento'
      setSelectPage(valueFilter)
    }
  }, [viewMode, selectedAlert])

  useEffect(() => {
    if (gridAction === '' || !selectedAlert || !selectedAlert.id) return
    switch (gridAction) {
      case 'add':
        setViewMode('add')
        setViewDetails(true)
        setHeaderTitle(t('configuration.AdministrationTypeDocuments.addHeader'))
        break
      case t('configuration.AdministrationTypeDocuments.details'):
        setViewMode('detail')
        setViewDetails(true)
        setHeaderTitle(t('configuration.AdministrationTypeDocuments.detailHeader', { typeDocumentName: (selectedAlert.document && selectedAlert.document.name) ? selectedAlert.document.name : '' }))
        break
      case t('assembliesPrincipalView.grid.btns.define.profile.data'):
        setViewMode('defineProfileData')
        setViewDetails(true)
        setHeaderTitle(t('configuration.AdministrationTypeDocuments.custom.data'))
        break

      case t('configuration.AdministrationTypeDocuments.delete'):
        setViewDeleteDialog(true)
        break

      default:
        break
    }

    setGridAction('')
  }, [selectedAlert, gridAction])

  const handleBackToList = useCallback(() => {
    setViewMode('list')
    setNameComponentUser('Administración de tipos de documentos')
    setHeaderTitle(t('configuration.AdministrationTypeDocuments.title2'))
    setSelectedAlert(null)
  }, [setViewMode, setNameComponentUser])

  const handleDeleteDocument = async () => {
    if (!selectedAlert) return

    toggleLoadingRequesting(true)

    try {
      await documentsTypeService.deleteTypeDocument(selectedAlert.document.id, token)
      await loadTypeDocuments()

      setViewDeleteDialog(false)
      setSelectedAlert(null)
    } catch (error) {
      toggleErrorRequesting(t('configuration.AdministrationTypdeDocuments.error.delete'), 4000, false, '/')
    } finally {
      toggleLoadingRequesting(false)
    }
  }

  useEffect(() => {
    if (confirmDelete) {
      handleDeleteDocument()
      setConfirmDelete(false)
    }
  }, [confirmDelete])

  const documentTypeOptions = [
    { id: '0', companyName: t('all') },
    { id: '1', companyName: t('configuration.AdministrationTypeDocuments.new.document') },
    { id: '2', companyName: t('configuration.AdministrationTypeDocuments.new.file') }
  ]

  const onChangePage = (page, varSelected) => {
    page = page || ''
    varSelected = varSelected || null
    setGridAction(page)
    setSelectedAlert(varSelected)
  }

  if (isLoading) return <div className='standard-wrapper'>
    <SimpleLoading />
  </div>

  return (
    <div className='standard-wrapper'>
      <div className='administrationTypesOfDocumentsView-header'>
        <HeaderHLPure title={headerTitle} />
      </div>
      <div className='administrationTypesOfDocumentsView-body'>
        {(viewMode === 'list') && (
          <div className='administrationTypesOfDocumentsView-wrapper'>
            <div className='administrationTypesOfDocumentsView-navbar'>
              <ButtonAddHLPure
                iconAdd
                onClickBtn={handleAddNewType}
                nameBtn={t('configuration.AdministrationTypeDocuments.addButton')}
              />
              <SearchBarHLPure
                searchValue={searchValue}
                onSearchChange={(e) => setSearchValue(e.target.value)}
                placeholder={t('configuration.AdministrationTypeDocuments.searchPlaceholder')}
              />
              <div className='administrationTypesOfDocumentsView-filter'>
                <DropDownBtnHLPure
                  iconFilter
                  valueItem='id'
                  nameOption='companyName'
                  optionsValue={documentTypeFilter}
                  optionsDropDown={documentTypeOptions}
                  onDropDownChange={(e) => setDocumentTypeFilter(e.target.value)}
                />
              </div>
            </div>
            <div className='administrationTypesOfDocumentsView-grid'>
              <GridSelectionHLPure
                skip={0}
                take={6}
                dataGrid={typeDocumentData}

                columnOne={true}
                titleRow1={t('configuration.AdministrationTypeDocuments.tableHeader.name')}
                cellColumnOne={CellColumnOne}
                headerColumnOne={AllHeadersColumns}
                widthColumnOne={widthCellOne}
                minResizableWidth1={'auto'}

                columnTwo={true}
                titleRow2={t('configuration.AdministrationTypeDocuments.tableHeader.type')}
                cellColumnTwo={CellColumnTwo}
                headerColumnTwo={AllHeadersColumns}
                widthColumnTwo={widthCellTwo}
                minResizableWidth2={widthCellTwo}

                columnThree={(is820) ? false : true}
                titleRow3={t('configuration.AdministrationTypeDocuments.tableHeader.data.profile')}
                cellColumnThree={CellColumnThree}
                headerColumnThree={AllHeadersColumns}
                widthColumnThree={widthCellThree}
                minResizableWidth3={widthCellThree}

                columnFour={true}
                titleRow4={t('configuration.AdministrationTypeDocuments.tableHeader.actions')}
                cellColumnFour={CellColumnFour}
                headerColumnFour={AllHeadersColumns}
                widthColumnFour={widthCellFour}
                minResizableWidth4={widthCellFour}
              />
            </div>
            <div className='administrationTypesOfDocumentsView-btns'>
              <ButtonHLPure
                nameBtn={t('button.return')}
                onClickBtn={() => history.push('/configuration')}
              />
            </div>
          </div>
        )}
        {(viewMode === 'add' || viewMode === 'detail') && (
          <AdministrationTypeDocumentForm
            viewMode={viewMode}
            selectedAlert={selectedAlert}
            setSelectedAlert={setSelectedAlert}
            inputValue={inputValue}
            setInputValue={setInputValue}
            selectPage={selectPage}
            setSelectPage={setSelectPage}
            textAreaValue={textAreaValue}
            setTextAreaValue={setTextAreaValue}
            analyzeAI={analyzeAI}
            setAnalyzeAI={setAnalyzeAI}
            handleCancel={handleBackToList}
            handleSubmit={viewMode === 'add' ? handleSaveTypeDocument : handleUpdateTypeDocument}
            dataProfileOptions={dataProfileOptions}
            setDataProfileSelected={setDataProfileSelected}
            dataProfileSelected={dataProfileSelected}
          />
        )}
        {(viewMode === 'defineProfileData') && (
          <AdministrationTypeDocumentDataProfile
            t={t}
            handleCancel={handleBackToList}
            typeDocumentSelected={selectedAlert}
            formatVariables={formatVariables}
            handleSumbitVariable={handleSumbitVariable}
            handleDeleteVariable={handleDeleteVariable}
          />
        )}
        {viewDeleteDialog && selectedAlert && (
          <DialogYesNoHLPure
            cancel={() => {
              setViewDeleteDialog(false)
              setGridAction('')
            }} textBtnCancel={t('button.cancel')}
            saveBtn={t('button.delete')}
            titleDialog={`${t('configuration.AdministrationTypeDocuments.modal.title')}${selectedAlert.infoType}`}
            handleSubmit={() => {
              setConfirmDelete(true)
            }}
          >
            <div className='digitalVaultBinView-modal-delete'>
              <LabelModalPure
                label={
                  selectedAlert?.document?.name && selectedAlert?.infoType
                    ? `${t('configuration.AdministrationTypeDocuments.modal.question')}${selectedAlert.infoType} ${selectedAlert.document.name}?`
                    : ''
                }
              />
            </div>
          </DialogYesNoHLPure>
        )}
      </div>
      <div className='administrationTypesOfDocumentsView-footer'>
        <PromotionalFooterPure />
      </div>
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        toggleLoadingRequesting={toggleLoadingRequesting}

        showCompletedRequesting={showCompletedRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}

        showErrorRequesting={showErrorRequesting}
        toggleErrorRequesting={toggleErrorRequestingFalse}
        messageError={messageError}
      />
    </div>
  )
}

export default AdministrationTypesOfDocumentsView